module.exports = __webpack_public_path__ + "fonts/futura-condensed-light-regular.a899aa2.woff";


//////////////////
// WEBPACK FOOTER
// ./src/components/posters/born-strong/fonts/futura-condensed-light-regular.woff
// module id = 383
// module chunks = 0